var _path, _line, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrimaryCare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.65 3.03429C0.65 1.71748 1.71748 0.65 3.03429 0.65H10.9657C12.2825 0.65 13.35 1.71748 13.35 3.03429V11C13.35 14.507 10.507 17.35 7 17.35C3.49299 17.35 0.65 14.507 0.65 11V3.03429Z",
    stroke: "#242E38",
    strokeWidth: 1.3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 9.5,
    x2: 14,
    y2: 9.5,
    stroke: "#242E38"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3,
    width: 2,
    height: 5,
    fill: "#242E38"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 6.5,
    width: 2,
    height: 5,
    transform: "rotate(-90 4.5 6.5)",
    fill: "#242E38"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryCare);
export default __webpack_public_path__ + "static/media/primary_care.51321427a11574c2ffd0abfe1515dc3f.svg";
export { ForwardRef as ReactComponent };